import React from 'react'
import { Provider as ReduxProvider } from 'react-redux'

import configureStore from 'utils/redux/configure-store'

const withReduxProvider = (WrappedComponent) => {
  const store = configureStore()
  return (props) => (
    <ReduxProvider store={store}>
      <WrappedComponent {...props} />
    </ReduxProvider>
  )
}

export default withReduxProvider
